import { Injectable, inject } from '@angular/core';
import { AppNotificationService } from './app-notification.service';
import { AuthTokenService } from './authentication/auth-token.service';
import { AppConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class AppWebsocketService {
  //#region properties
  appNotificationService = inject(AppNotificationService);
  private socket: WebSocket;
  private reconnectInterval = 20000; // 20 seconds
  private isManuallyClosed = false;
  //#endregion

  // Connect to the WebSocket server
  connect(): void {
    // Use token as query parameter, encoding it safely
    const url = `${
      AppConfigService.config.notificationSocketUrl
    }?token=Bearer ${AuthTokenService.getAccessToken()}`;

    this.socket = new WebSocket(url);

    // Connection opened
    this.socket.onopen = () => {
      console.log('[WebSocket] Connection opened');
    };

    // Receiving message from server
    this.socket.onmessage = (event) => {
      let data = JSON.parse(event.data);

      this.appNotificationService.setNewNotifications(data);
    };

    // Connection closed
    this.socket.onclose = (event) => {
      console.warn('[WebSocket] Connection closed:', event);
      if (!this.isManuallyClosed) {
        this.reconnect();
      }
    };

    // Handling socket error
    this.socket.onerror = (error) => {
      console.error('[WebSocket] Error:', error);
      this.socket.close(); // triggers onclose -> reconnect
    };
  }

  // Send messages to the WebSocket server
  send(message: any): void {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(message));
    } else {
      console.warn('[WebSocket] Cannot send message, socket not open');
    }
  }

  // Close the WebSocket connection manually
  close(): void {
    this.isManuallyClosed = true;
    this.socket?.close();
  }

  // Reconnect after the connection is closed
  private reconnect() {
    console.log(
      `[WebSocket] Attempting to reconnect in ${
        this.reconnectInterval / 1000
      }s...`
    );
    setTimeout(() => {
      this.connect();
    }, this.reconnectInterval);
  }
}
